import { createContext } from "react";
import type { AvailableLocales } from "../i18n";

export type ILangContext = {
  currentLang: AvailableLocales;
} | null;

export const LangContext = createContext<ILangContext>(null);
